export const getDifferenceInDays = (startDate, endDate) => {
  const msInDay = 1000 * 3600 * 24
  const differenceInMs = endDate.getTime() - startDate.getTime()

  let differenceInDays = Math.floor(differenceInMs / msInDay)

  const remainingMs = differenceInMs % msInDay

  if (remainingMs > 0) {
    const remainingHours = remainingMs / (1000 * 3600)
    if (remainingHours > 3) {
      differenceInDays += 1
    }
  }

  return differenceInDays < 1 ? 1 : differenceInDays
}
